export default "__VITE_ASSET__C3ieeDbw__"